exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50}.subtitle{font-weight:400;font-size:1.5rem;line-height:1.5rem;color:#006064}.subsection{font-weight:500;font-size:1rem;color:#161c2d}.subbody{font-size:.8rem;color:#161c2d}.hyphens{hyphens:auto}.v-data-table__wrapper>table>thead>tr>th{border:hidden!important}.v-data-table__wrapper>table>tbody>tr:hover{background:inherit!important}.text-block{white-space:pre-line}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74f1d1be","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/WorkSmall.vue
// module id = 70
// module chunks = 0